import { useEffect, useContext, useCallback } from 'react';
import { CartContext } from '../cart/ContextProvider';
import { onAuthStateChanged } from "firebase/auth";
import { db, auth } from '../Authentication/firebase';
import { collection, getDocs, query, where, updateDoc, doc } from 'firebase/firestore';
import axios from 'axios';


function useStartEffect(dependency) {
  const { setWishlist, setCartId, setUser, setInitialLoading, setCartItemsArray, setUserId, setCartItems, setCounter, setTotalPrice, setWishlistId, setWishlistItemsArray } = useContext(CartContext);

  const fetchCartItems = useCallback(setCartItemsArray, []);
  const fetchWishlistItems = useCallback(setWishlistItemsArray, []);
  const handleUserUpdate = useCallback(setUser, []);

  useEffect(() => {
    setInitialLoading(true);
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      console.log("Before if user");
      if (user) {
        console.log("printing user"+user);
        handleUserUpdate(user);
        const q = query(collection(db, "users"), where("uid", "==", user.uid));
        const docs = await getDocs(q);

        docs.forEach(async (userDoc) => {
          setUserId(userDoc.id);
          console.log(userDoc.id);
          
          // Check if user has a wishListId, if not, create one using uuid

          setWishlistId(userDoc.data().wishListId);
          setCartId(userDoc.data().cartId)


          const cartItemsResponse = await axios.get(`https://jackpotbackend.vercel.app/cart/${userDoc.data().cartId}`);
          const wishlistItemsResponse = await axios.get(`https://jackpotbackend.vercel.app/wishlist/user/${userDoc.data().wishListId}`);

          fetchCartItems(cartItemsResponse.data.cart);
          fetchWishlistItems(wishlistItemsResponse.data.wishlist);
        });
      } else {
        setInitialLoading(false);
        handleUserUpdate(null);
        setCartItems([]);
        setWishlist([]);
        setCounter(0);
        setTotalPrice(0);
      }
    });

    // Clean-up function to unsubscribe when component unmounts
    return () => unsubscribe();
  }, [handleUserUpdate, fetchCartItems]);
}

export default useStartEffect;
